import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28daf83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "overflow-auto",
  style: {"max-height":"70vh"}
}
const _hoisted_2 = { class: "table table-tenant table-hover" }
const _hoisted_3 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_4 = { colspan: "12" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "width-control" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "width-control" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "dialog-footer" }

import { ref } from "vue";
import PaymentService from "../../services/PaymentService";
import { CryptoTransactionStatusOptions } from "@/core/types/crypto/CryptoStatus";
import TinyCopyBox from "@/components/TinyCopyBox.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CryptoTransaction',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const data = ref<any>([]);
const isLoading = ref(false);
const title = ref("");

const criteria = ref<any>({
  page: 1,
  size: 25,
  cryptoId: 0,
  sortField: "createdOn",
  sortFlag: true,
});
const show = (item: any) => {
  dialogRef.value = true;
  title.value = item.name;
  criteria.value.cryptoId = item.id;
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    criteria.value.page = _page;
    const res = await PaymentService.queryCryptoTransactions(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const reset = () => {
  dialogRef.value = false;
  data.value = [];
  title.value = "";
  criteria.value = {
    page: 1,
    size: 25,
    cryptoId: 0,
    sortField: "createdOn",
    sortFlag: true,
  };
};

const getStatusLabel = (value: number) => {
  const option = CryptoTransactionStatusOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

const accountSelected = ref(0);

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_scale_loader = _resolveComponent("scale-loader")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    title: title.value,
    width: "1400",
    "align-center": "",
    "before-close": reset,
    style: {"max-height":"90vh"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.transactionHashId")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.paymentId")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.paymentNo")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.fromAddress")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.user")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_scale_loader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.transactionHash), 1),
                          _createVNode(TinyCopyBox, {
                            val: item.transactionHash.toString()
                          }, null, 8, ["val"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.paymentId), 1),
                      _createElementVNode("td", null, [
                        (item.inUsePayment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.inUsePayment.paymentNumber), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_BalanceShow, {
                          balance: item.amount
                        }, null, 8, ["balance"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(getStatusLabel(item.status)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.fromAddress), 1),
                          _createVNode(TinyCopyBox, {
                            val: item.transactionHash.toString()
                          }, null, 8, ["val"])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        (item.inUsePayment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_UserInfo, {
                                user: item.inUsePayment.user,
                                class: "me-2"
                              }, null, 8, ["user"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_7))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})